function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Button, ButtonIcon, ButtonLabel } from './';
import Dropzone from 'react-dropzone';

class ButtonUpload extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onUpload", (acceptedFiles, rejectedFiles) => {
      if (this.props.onUpload) {
        this.props.onUpload(acceptedFiles, rejectedFiles);
      }
    });
  }

  render() {
    const _this$props = this.props,
          className = _this$props.className,
          label = _this$props.label,
          icon = _this$props.icon,
          accept = _this$props.accept,
          multiple = _this$props.multiple;
    return React.createElement(Dropzone, {
      multiple: multiple,
      accept: accept,
      onDrop: event => this.onUpload(event)
    }, ({
      getRootProps,
      getInputProps,
      isDragActive,
      isDragAccept,
      isDragReject
    }) => React.createElement(Button, _extends({}, getRootProps(), {
      className: className
    }), React.createElement("input", getInputProps()), React.createElement(ButtonIcon, {
      icon: icon
    }), React.createElement(ButtonLabel, {
      label: label
    })));
  }

}

_defineProperty(ButtonUpload, "defaultProps", {
  className: "admin-button  admin-button--secondary",
  label: "Upload",
  icon: ""
});

export default ButtonUpload;